// extracted by mini-css-extract-plugin
export var downArrow = "_a4-0";
export var label = "_a4-1";
export var treatmentCard = "_a4-3";
export var upArrow = "_a4-2";